import React from "react";

export const ExclamationIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
    >
      <g id="exclamation" transform="translate(-3 -3)">
        <circle
          id="Ellipse_121"
          data-name="Ellipse 121"
          cx="8.5"
          cy="8.5"
          r="8.5"
          transform="translate(3 3)"
          fill="#f89d1c"
        />
        <g
          id="Group_12163"
          data-name="Group 12163"
          transform="translate(10.378 5.787)"
        >
          <circle
            id="Ellipse_122"
            data-name="Ellipse 122"
            cx="0.905"
            cy="0.905"
            r="0.905"
            transform="translate(0.363 9.908)"
            fill="#fff"
          />
          <path
            id="Path_225474"
            data-name="Path 225474"
            d="M29.015,12.347a1.268,1.268,0,0,0-1.268,1.268l.516,6.762a.753.753,0,1,0,1.506,0l.515-6.762a1.268,1.268,0,0,0-1.268-1.268Z"
            transform="translate(-27.747 -12.347)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};
